/**
 * Funkcje pomocnicze do wykrywania środowiska uruchomieniowego (Web vs Tauri Desktop)
 */

declare global {
  interface Window {
    __TAURI_INTERNALS__?: unknown;
    __TAURI__?: unknown;
  }
}

/**
 * Sprawdza, czy aplikacja jest uruchomiona wewnątrz natywnego kontenera Tauri (Desktop).
 */
export function isTauri(): boolean {
  return typeof window !== 'undefined' && (
    window.__TAURI_INTERNALS__ !== undefined ||
    window.__TAURI__ !== undefined
  );
}

/**
 * Zwraca czytelną nazwę trybu uruchomienia aplikacji.
 */
export function getAppEnvironment(): 'desktop' | 'web' {
  return isTauri() ? 'desktop' : 'web';
}
